import React from 'react';
import { Card, CardActions, CardContent, Grid } from '@material-ui/core';
import type { Theme } from '@material-ui/core';

import { ActionButton, Heading } from '@klp/design';
import type { IconName, PictogramNameType } from '@klp/design/Illustrations';
import { Illustration } from '@klp/design/Illustrations';
import { useKlpStyles } from '@klp/design/Theme';

export interface IOwnProps extends React.HTMLAttributes<HTMLDivElement> {
    title: string;
    icon?: IconName;
    pictogram?: PictogramNameType;
    actionRoute?: string;
    actionClickHandler?: () => void;
    actionText: string;
    external?: boolean;
    klpPalette?: string;
}

const styles = (theme: Theme) => ({
    cardContentGrid: {
        justifyContent: 'space-between',
        alignItems: 'flex-end',
    },
    card: {
        padding: theme.spacing(2),
        borderRadius: theme.spacing(0.2),
    },
    cardActions: {
        marginTop: theme.spacing(4),
    },
});

export type IFrontpageCardProps = IOwnProps;

export const FrontpageCard: React.FC<IFrontpageCardProps> = (props) => {
    const {
        children,
        actionClickHandler,
        actionRoute,
        actionText,
        icon,
        pictogram,
        title,
        klpPalette,
        external,
        ...rest
    } = props;
    const classes = useKlpStyles({}, styles);

    return (
        <Card className={classes.card} {...rest}>
            <CardContent>
                <Grid container={true} className={classes.cardContentGrid}>
                    <Grid item={true}>
                        <Heading klpHeadingLevel="TWO" translation={title} />
                    </Grid>
                    <Grid item={true}>
                        <Illustration
                            icon={icon}
                            pictogram={pictogram}
                            klpPalette={klpPalette as any}
                            klpColor="medium"
                            size="medium"
                            data-testid="FrontpageCard-Illustration"
                        />
                    </Grid>
                </Grid>
                {children}
            </CardContent>
            <CardActions className={classes.cardActions}>
                {!external ? (
                    <ActionButton
                        actionType="button"
                        translation={actionText}
                        target={actionRoute}
                        clickHandler={actionClickHandler}
                        klpTypographyVariant="small"
                    />
                ) : (
                    <ActionButton
                        actionType="external"
                        translation={actionText}
                        target={actionRoute}
                        clickHandler={actionClickHandler}
                        klpTypographyVariant="small"
                    />
                )}
            </CardActions>
        </Card>
    );
};

FrontpageCard.displayName = 'FrontpageCard';
